import { Component, Inject } from '@angular/core';

import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

export interface ApplyChangesDialogData {
  campaigns: Array<{
    campaignId: string;
    campaignTitle: string;
    receiptId: string;
    hasChanges: boolean;
    actionLabel: string;
  }>;
  actionType: 'eligible' | 'fraud' | 'reject' | 'save';
  actionLabel: string;
}

export interface ApplyChangesDialogResult {
  selectedCampaignIds: string[];
  applyToAll: boolean;
}

@Component({
  selector: 'app-apply-changes-dialog',
  templateUrl: './apply-changes-dialog.component.html',
  styleUrls: ['./apply-changes-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    FormsModule
]
})
export class ApplyChangesDialogComponent {
  selectAll = false;
  selectedCampaigns: Set<string> = new Set();

  constructor(
    public dialogRef: MatDialogRef<ApplyChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApplyChangesDialogData
  ) {
    this.dialogRef.updateSize('329px', '345px');

    // Pre-select campaigns that have changes
    this.data.campaigns.forEach(campaign => {
      if (campaign.hasChanges) {
        this.selectedCampaigns.add(campaign.campaignId);
      }
    });
    this.updateSelectAll();
  }

  toggleSelectAll(): void {
    if (this.selectAll) {
      this.data.campaigns.forEach(campaign => {
        this.selectedCampaigns.add(campaign.campaignId);
      });
    } else {
      this.selectedCampaigns.clear();
    }
  }

  toggleCampaign(campaignId: string): void {
    if (this.selectedCampaigns.has(campaignId)) {
      this.selectedCampaigns.delete(campaignId);
    } else {
      this.selectedCampaigns.add(campaignId);
    }
    this.updateSelectAll();
  }

  isCampaignSelected(campaignId: string): boolean {
    return this.selectedCampaigns.has(campaignId);
  }

  updateSelectAll(): void {
    this.selectAll = this.selectedCampaigns.size === this.data.campaigns.length;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onApply(): void {
    const result: ApplyChangesDialogResult = {
      selectedCampaignIds: Array.from(this.selectedCampaigns),
      applyToAll: this.selectAll
    };
    this.dialogRef.close(result);
  }

  get selectedCount(): number {
    return this.selectedCampaigns.size;
  }

  get hasSelection(): boolean {
    return this.selectedCampaigns.size > 0;
  }
}
